import {
  LoginState,
  AuthenticateUserAction,
  ChangeLoginInformationAlreadySubmissionStateAction,
  ToggleInvalidLoginAction,
  ToggleMyleCommunicationIssuesStateAction
} from "./type";

export function authenticateUserHandler(state: LoginState, action: AuthenticateUserAction) {
    return Object.assign({}, state, { isAuthenticated: action.payload.isAuthenticated });
}

export function changeLoginInformationAlreadySubmissionStateHandler(state: LoginState, action: ChangeLoginInformationAlreadySubmissionStateAction) {
    return Object.assign({}, state, { isAlreadySubmitted: action.payload.isAlreadySubmitted });
}

export function changeValidLoginStateHandler(state: LoginState, action: ToggleInvalidLoginAction) {
    return Object.assign({}, state, { isValidLogin: action.payload.isValid });
}

export function changeMyleCommunicationIssuesHandler(state: LoginState, action: ToggleMyleCommunicationIssuesStateAction) {
    return Object.assign({}, state, { isHavingIssuesWithConnectionToMyle: action.payload.isHavingIssuesWithConnectionToMyle })
}



// WEBPACK FOOTER //
// ./src/store/Login/handlers.ts